
// import genesyscloudService from '@/services/genesyscloud-service'
import platformClient from 'purecloud-platform-client-v2'
import { defineComponent } from 'vue'

const defaulProfilePicture = './img/default-face.png'

export default defineComponent({
  name: 'QueueMemberDetails',
  props: {
    queueMember: {
      type: Object as () => platformClient.Models.QueueMember
    }
  },
  computed: {
    name: function () {
      return this.queueMember?.name
    },
    presence: function () {
      return this.queueMember?.user?.presence?.presenceDefinition?.systemPresence
    },
    routingStatus: function () {
      return this.queueMember?.user?.routingStatus?.status
    },
    imageURI: function () {
      const images = this.queueMember?.user?.images
      let imageUri = defaulProfilePicture
      if (images) imageUri = images[images.length - 1].imageUri || imageUri

      return imageUri
    }
  }
})
